<template>
  <div>
    <v-container class="screen2 privacy">
      <v-layout row justify-center>
        <v-flex xs12 sm8>
            <h1 class="text-xs-center">Согласие на обработку персональных данных сайтом малина-садко.рф</h1>
            <div>
              <router-link tag="a" to="/">на главную страницу</router-link>
            </div>
            <div>
            Настоящим в соответствии с Федеральным законом № 152-ФЗ «О персональных данных» от 27.07.2006 года свободно, своей волей и в своем интересе выражаю свое безусловное согласие на обработку моих персональных данных, сайтом agenio42.ru (далее по тексту - Оператор).
            Персональные данные - любая информация, относящаяся к определенному или определяемому на основании такой информации физическому лицу.
            Настоящее Согласие выдано мною на обработку следующих персональных данных:
            </div>
            <div>
            - телефон;<br>
            - адрес электронной почты.
            </div>
            <div>
            Согласие дано Оператору для совершения следующих действий с моими персональными данными с использованием средств автоматизации и/или без использования таких средств: сбор, систематизация, накопление, хранение, уточнение (обновление, изменение), использование, обезличивание, а также осуществление любых иных действий, предусмотренных действующим законодательством РФ как неавтоматизированными, так и автоматизированными способами.
            </div>
            <div>
            Данное согласие дается Оператору для обработки моих персональных данных в следующих целях:
            - предоставление мне услуг/работ;<br>
            - направление в мой адрес уведомлений, касающихся предоставляемых услуг/работ;<br>
            - подготовка и направление ответов на мои запросы;<br>
            - направление в мой адрес информации, в том числе рекламной, о мероприятиях/товарах/услугах/работах Оператора.
            </div>
            <div>
            Настоящее согласие действует до момента его отзыва путем направления соответствующего уведомления на электронный адрес malinasadkoveles@gmail.com. В случае отзыва мною согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без моего согласия при наличии оснований, указанных в пунктах 2 – 11 части 1 статьи 6, части 2 статьи 10 и части 2 статьи 11 Федерального закона №152-ФЗ «О персональных данных» от 27.06.2006 г.
            </div>
            <div>
              <router-link tag="a" to="/">на главную страницу</router-link>
            </div>
        </v-flex>
      </v-layout>
    </v-container>

    <!--<app-button-go-back :goto="goto"></app-button-go-back>-->

  </div>
</template>

<script>
export default {
  data () {
    return {
      goto: { path: '/' }
    }
  }
}
</script>

<style scoped>
.privacy div {
  margin: 15px 0px;
}

.privacy a,
.privacy a:hover,
.privacy a:visited,
.privacy a:active {
  color: blue;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Privacy.vue